export type TestableGQL<T> = {
  [K in keyof T]: TestableGQL<NonNullable<T[K]>>;
};

export const isNotNull = <T>(value: T): value is NonNullable<T> => {
  return value !== null;
};

export const isTruthy = <T>(value: T): value is T => {
  return !!value;
};

export type DeepPartial<T> = T extends Function
  ? T
  : T extends object
    ? { [P in keyof T]?: DeepPartial<T[P]> }
    : T;

export type DeepNullable<T> = {
  [K in keyof T]: T[K] extends object ? DeepNullable<T[K]> | null : T[K] | null;
};

export type NonEmptyArray<T> = [T, ...T[]];

export function isNonEmptyArray<A>(arr: A[]): arr is NonEmptyArray<A> {
  return arr?.length > 0;
}

export function asNonEmptyArray<A>(arr: A[]): NonEmptyArray<A> | undefined {
  return isNonEmptyArray(arr) ? arr : undefined;
}
